export default __webpack_public_path__ + "static/media/texture-green.d7a9a3b6.png";